//Tipso https://github.com/object505/tipso

(function () {
    'use strict';

    angular
        .module('iMatApp')
        .directive('imatTooltip', imatTooltip);

    imatTooltip.$inject = [];
    
    function imatTooltip() {
        var directive = {
            restrict: 'A',
            link: link
        };
        return directive;

        function link(scope, elm, attrs) {
            var backgroundColor = getTooltipColor(attrs.tooltipColor);

            elm.tipso({
                useTitle : false,
                width: attrs.tooltipWidth || 255,
                background: backgroundColor,
                content: attrs.tooltipText,
                size: attrs.tooltipSize || 'small',
                position: attrs.tooltipPosition || 'top',
                delay: attrs.tooltipDelay || 200,
                hideDelay: attrs.tooltiHideDelay || 0
            });

            elm.on('$destroy', function () {
                destroyTooltip(elm);
            })
        }

        function getTooltipColor(attr) {
            switch (attr) {
                case 'active':
                    return '#00b1ea'
                    break;
                case 'warning':
                    return '#ea6554'
                    break;
                default:
                    return '#3d3d3d'
            }
        }

        function destroyTooltip(element) {
            element.tipso('hide');
            element.tipso('destroy');
        }
    }
})();